export default {
      id: "triangular-usage",
      viewBox: "0 0 30 26",
      url: __webpack_public_path__ + "icons.svg#triangular",
      toString: function () {
        return this.url;
      }
    }